import React, { useRef, useEffect } from 'react';
import logo from '../images/lq-logo.svg';
import LetsExplore from './LetsExplore';
import exploreImage from '../images/image1.jpg';

const LINE_PATHS = [
    { d: "M-137.37 107.515C-89.4411 103.561 -41.4085 100.779 6.66937 99.055C80.5155 96.4074 154.469 96.2585 228.321 98.2041C237.745 98.6765 247.145 99.4592 256.401 100.875C269.431 102.876 282.216 106.09 294.302 111.562C321.608 123.815 346.206 149.726 344.862 181.051C344.043 197.767 333.251 209.497 317.62 214.387C303.18 219.227 287.193 219.887 272.993 224.744C260.509 228.806 248.685 236.482 242.393 248.284C240.375 251.94 238.893 255.868 237.797 259.92C236.702 263.972 235.992 268.149 235.519 272.304C232.232 311.142 236.065 350.168 238.874 388.961", sign: -1 },
    { d: "M485.13 12.7498C455.327 12.9714 421.609 10.5188 387.588 9.66698C319.127 7.95092 249.431 12.7144 207.906 58.7801C182.926 86.1049 179.309 123.29 170.682 157.811C156.042 214.983 114.3 223.459 61.1035 224.64C42.9804 225.161 24.8519 225.342 6.72256 225.345C-11.4068 225.35 -29.5379 225.177 -47.6655 224.99", sign: -1 },
    { d: "M-177.051 25.9694C-125.969 13.8764 -73.7768 4.91767 -21.2227 3.54553C-16.0417 3.56149 -10.8723 3.80436 -5.76491 4.4399C-1.56342 4.91944 2.60086 5.7296 6.66937 6.86595C18.9796 10.3051 30.4087 16.7288 39.332 25.9987C55.5006 42.2241 60.8908 64.8784 64.0321 86.977C67.5423 107.843 68.9304 131.899 83.9679 147.951C91.4181 155.676 101.454 159.462 112.092 161.59C127.515 164.552 143.339 165.596 159.02 166.567C235.27 170.548 311.8 168.728 387.816 161.504C414.381 158.979 440.883 155.795 467.288 151.966", sign: 1 },
];

const W = 390, H = 263;
const DURATION = 3000;
const easeOut = t => 1 - Math.pow(1 - t, 3);

const Home = () => {
    const canvasRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return;

        const dpr = window.devicePixelRatio || 1;
        canvas.width = W * dpr;
        canvas.height = H * dpr;

        const ctx = canvas.getContext('2d');
        ctx.scale(dpr, dpr);

        // Use a hidden SVG element to read getTotalLength() for each path
        const ns = 'http://www.w3.org/2000/svg';
        const tempSvg = document.createElementNS(ns, 'svg');
        tempSvg.style.cssText = 'position:absolute;opacity:0;pointer-events:none;width:0;height:0;overflow:hidden';
        document.body.appendChild(tempSvg);

        const lengths = LINE_PATHS.map(({ d }) => {
            const el = document.createElementNS(ns, 'path');
            el.setAttribute('d', d);
            tempSvg.appendChild(el);
            return el.getTotalLength();
        });

        document.body.removeChild(tempSvg);

        const path2ds = LINE_PATHS.map(({ d }) => new Path2D(d));

        let startTime = null;
        let raf;

        function frame(ts) {
            if (!startTime) startTime = ts;
            const t = Math.min((ts - startTime) / DURATION, 1);
            const progress = easeOut(t);

            ctx.clearRect(0, 0, W, H);
            ctx.strokeStyle = '#F8F3FF';
            ctx.lineWidth = 8;
            ctx.lineJoin = 'bevel';

            LINE_PATHS.forEach(({ sign }, i) => {
                const len = lengths[i];
                ctx.setLineDash([len]);
                ctx.lineDashOffset = sign * len * (1 - progress);
                ctx.beginPath();
                ctx.stroke(path2ds[i]);
            });

            if (t < 1) raf = requestAnimationFrame(frame);
        }

        raf = requestAnimationFrame(frame);
        return () => cancelAnimationFrame(raf);
    }, []);

    return <>
        <div className="h-100 text-center d-flex align-items-center justify-content-center flex-column overflow-hidden"
             style={{background: '#BC88FC', backgroundSize: '100%'}}>
            <div></div>
            <div className="d-inline-block px-3 pb-4">
                <img src={logo} alt="logo" className="fade-up fade-up-1"/>
                <p className="fs-26 my-4 fade-up fade-up-2" style={{lineHeight: '35px'}}>Accessible audio-based queer history</p>
                <div className="fade-up fade-up-3">
                    <LetsExplore exploreImage={exploreImage}/>
                </div>
            </div>
            <div className="position-relative w-100">
                <canvas
                    ref={canvasRef}
                    className="w-100 position-absolute start-0 top-0 bottom-0"
                    style={{height: 'auto'}}
                />
            </div>
        </div>
    </>;
};

export default Home;
